import logoSrc from 'styles/assets/png/foresight_logo.png';

import classes from 'components/common/ForesightLogo/ForesightLogo.module.scss';

interface ForesightLogoProps {
    width?: number;
    height?: number;
    withBackground?: boolean;
}

export const ForesightLogo = ({ width = 30, height, withBackground }: ForesightLogoProps) => {
    return (
        <img
            className={`${classes.img}${withBackground ? ` ${classes.withBackground}` : ''}`}
            src={logoSrc}
            alt={'foresight_logo'}
            width={width}
            height={height}
        />
    );
};
